import InlineUploadComponent from '72cms-ui/components/helpers/InlineUploadComponent';
import InlineAssetComponent from '72cms-ui/components/table-elements/InlineGlobalModalAssetComponent';
import InlineImageComponent from '72cms-ui/components/table-elements/InlineImageComponent';
import InlineInputComponent from '72cms-ui/components/helpers/InlineInputComponent';
import AssetInfoComponent from '72cms-ui/components/table-elements/AssetInfoComponent';
import FileFormComponent from '72cms-ui/components/table-elements/FileFormComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        file: {
            component: InlineAssetComponent,
        },
        file_name: {
            label: 'File name',
            component: AssetInfoComponent,
            assetField: 'file',
        },
        comment: {
            component: InlineInputComponent,
        },
    },
    sortable: [],
    filterable: [],
    // modalFormComponent: FileFormComponent,
    inlineFormComponent: InlineUploadComponent,
    hideIfEmpty: true,
    description: 'Upload page documents here',
    defaultItem: {
        activate: true,
    },
    pagination: false,
    searchable: false,
    treeView: false,
    toolbarDisabled: true,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            primary: true,
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.page-page_files.js